/* template */
<template><div class="travel-service-mulit"><div class="service-title">出行服务</div><div class="service-list"><div :class="({          'bxgp': item.type === 1,          'tgwu': item.type === 2,          'selected': item.type === selectedType        })" v-for="(item, index) in (rightsInfo)" :key="item.title" class="service-item"><div class="suggest-text" v-if="(item.type === 2)">建议添加</div><div class="title">{{ item.title }}</div><div class="ex-title-wrap"><div class="ex-title-left-icon"></div><div class="ex-title">{{ item.extrude_tips_map?.make_order?.title }}</div><div class="ex-title-right-icon"></div></div><mpx-view @tap="openRightsDescDrawer(item.type)" class="ex-subhead">{{+(item.fee / 100).toFixed(2)}}元/份，{{ item.extrude_tips_map?.make_order?.subhead }}<spring-icon h="16" w="8" color="rgba(153, 153, 153, 0.8)" name="right-thin-arrow" :externClass='["mulit-right-icon"].join(" ")'/></mpx-view><mpx-view :class="({            'multi-select-box-yes': item.type === selectedType,          })" @click="selectService(item)" class="multi-select-box"><spring-icon h="18" w="18" color="#fff" name="checkbox-check-mark"/></mpx-view></div></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m23d087de"}'>
  @font-face
    font-family MFYuanHei
    src url('https://ut-static.udache.com/webx/sfc/zFeca_fdUIuxJfpXUFGY5_ZaoZiGongFangYuanHeiTi-2-Medium.otf')
  .travel-service-mulit
    border-radius 8px
    background #FFFFFF
    .service-title
      padding 16px 12px 10px
      font-family PingFang SC
      font-size 16px
      font-weight 600
      line-height 16px
      letter-spacing 0px
      color #000
    .service-list
      display flex
      justify-content space-between
      padding 0px 4px 4px
      .service-item
        position relative
        display flex
        flex-direction column
        justify-content center
        align-items center
        width calc(50% - 2px)
        height 117px
        .suggest-text 
          position absolute
          left 0px
          top 0px
          background linear-gradient(121deg, #FF8C00 7%, #FF6400 64%)
          box-sizing border-box
          border 1px solid rgba(255, 201, 100, 0.5)
          font-family PingFang SC
          font-size 10px
          font-weight 500
          letter-spacing 0px
          font-variation-settings "opsz" auto
          color #FFFFFF
          width 56px
          height 18px
          border-radius 28px 28px 28px 0px
          display flex
          align-items center
          justify-content center
        .title
          font-family MFYuanHei
          flex-shrink 0
          font-size 15px
          font-weight normal
          margin-bottom 10px
          -webkit-background-clip text!important
          -webkit-text-fill-color transparent!important
          background-clip text!important
        .ex-title-wrap
          display flex
          width 100%
          align-items center
          margin-bottom 8px
          padding: 0px 8px;
          box-sizing: border-box;
          .ex-title-left-icon
            flex 1
            height 1px
            opacity 0.8
          .ex-title-right-icon
            flex 1
            height 1px
            opacity 0.8
          .ex-title
            font-family PingFang SC
            font-size 12px
            font-weight normal
            letter-spacing 0px
            margin 0 4px
            font-variation-settings "opsz" auto
        .ex-subhead
          display flex
          align-items center
          font-family PingFang SC
          font-weight 400
          font-size 10px
          color #999
          margin-bottom 10px
          .mulit-right-icon
            margin-left 4px
        .multi-select-box
          width 18px
          height 18px
          border-radius 6px
          border 1px solid #E6EAED
          background #fff
          display flex
          align-items center
          justify-content center
        .multi-select-box-yes
          background #FF6400
      .bxgp
        border-radius 10px
        opacity 0.8
        background linear-gradient(180deg, #E6F2FF 0%, rgba(217, 234, 255, 0.25) 95%)
        box-sizing border-box
        &.selected
          border 1px solid rgba(43, 125, 247, 0.3)
        .title
          background linear-gradient(108deg, #2B7DF7 30%, #82BAFF 120%)
        .ex-title-wrap
          .ex-title-left-icon
            background: linear-gradient(270deg, #2B7DF7 0%, rgba(43, 125, 247, 0) 99%);
          .ex-title-right-icon
            background: linear-gradient(90deg, #2B7DF7 0%, rgba(43, 125, 247, 0) 100%);
          .ex-title
            color #2B7DF7
      .tgwu
        border-radius 10px
        opacity 0.8
        background linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 32%, rgba(255, 255, 255, 0) 81%, rgba(255, 255, 255, 0) 100%), linear-gradient(180deg, #FCEFDD 7%, rgba(253, 244, 230, 0.25) 97%)
        box-sizing border-box
        
        &.selected
          border 1px solid rgba(255, 100, 0, 0.3)
        .title
          background linear-gradient(108deg, #FF4000 30%, #FF6400 120%)
        .ex-title-wrap
          .ex-title-left-icon
            background linear-gradient(270deg, #FF6400 0%, #FF6400 0%, rgba(255, 100, 0, 0) 99%)
          .ex-title-right-icon
            background linear-gradient(90deg, #FF6400 0%, rgba(255, 100, 0, 0) 100%)
          .ex-title
            color #FF6400
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m23d087de"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./mulit-service.mpx.js?isComponent&outputPath=components%2Fmulit-service23d087de%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./mulit-service.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fmulit-service23d087de%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m23d087de"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/mulit-service23d087de/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'spring-icon':getComponent(require("../../../../../node_modules/@didi/spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
